import { useCallback, useRef, useState } from "react";
import axios from "axios";

// Instancia aislada: los interceptores globales de autenticación de MovilesPay
// no deben interpretar un 401 de API Perú como vencimiento del JWT del sistema.
const dniApi = axios.create({ timeout: 12000 });

// Misma fuente y credencial utilizadas por Cards.jsx.
export default function useDriverDniLookup(applyResult) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const latest = useRef(0);
  const lookup = useCallback(async (dni) => {
    const value = String(dni || "").replace(/\D/g, "");
    const requestId = ++latest.current;
    setMessage("");
    if (!/^\d{8}$/.test(value)) { setLoading(false); return; }
    const token = process.env.REACT_APP_APIPERU_TOKEN;
    if (!token) { setMessage("API DNI sin configurar; ingrese los nombres manualmente."); return; }
    setLoading(true);
    try {
      const response = await dniApi.post("https://apiperu.dev/api/dni", { dni: value }, {
        headers: { Authorization: `Bearer ${token}` }, timeout: 12000,
      });
      if (requestId !== latest.current) return;
      const data = response?.data?.data || response?.data || {};
      const first = String(data.nombres || data.name || "").trim();
      const paternal = String(data.apellido_paterno || data.apellidoPaterno || data.paterno || "").trim();
      const maternal = String(data.apellido_materno || data.apellidoMaterno || data.materno || "").trim();
      if (!first || !(paternal || maternal)) { setMessage("No se encontraron datos completos; ingréselos manualmente."); return; }
      applyResult(value, first, [paternal, maternal].filter(Boolean).join(" "));
    } catch (error) {
      if (requestId === latest.current) {
        const status = error?.response?.status;
        setMessage(status === 401 || status === 403
          ? "La consulta de DNI fue rechazada por API Perú. Verifique su credencial; puede ingresar los datos manualmente."
          : "No se pudo consultar el DNI; puede ingresar los datos manualmente.");
      }
    } finally { if (requestId === latest.current) setLoading(false); }
  }, [applyResult]);
  const invalidate = useCallback(() => { latest.current += 1; setLoading(false); setMessage(""); }, []);
  return { lookup, invalidate, loading, message };
}
